export default __webpack_public_path__ + "static/media/start-therapy-icon.d521ee7c.png";